import {formatTime} from './formatTime';
import {Duration} from '../../../Domain/Duration';

export function formatDuration(duration: Duration | null): {formatted: string; unit?: string} {
    if (duration === null) {
        return {formatted: '-:--'};
    }
    return {formatted: formatTime(duration).formatted};
}
